import React from "react";
import {
    View,
    Text,
    StyleSheet,
    Svg,
    Path,
    G,
    Circle,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    icon: {
        marginRight: "3px"
    },
    text: {
        fontSize: "8px",
        color: "#243746",
        fontWeight: "bold",
    }
});

const Icon = () => (
    <Svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 40 40'
    >
      <G transform='translate(-1440 -167)'>
        <G data-name='Group 11458' transform='translate(1440 167)'>
          <Circle
            cx='20'
            cy='20'
            r='20'
            fill='#243746'
            data-name='Ellipse 993'
          ></Circle>
        </G>
        <Path
          fill='#fff'
          d='M10.293 19.382a1.375 1.375 0 01-1.112-.576l-3.575-4.919a1.49 1.49 0 01.27-2.033 1.357 1.357 0 011.954.281l2.353 3.233L16.1 5.481a1.365 1.365 0 011.923-.464 1.487 1.487 0 01.447 2L11.479 18.7a1.382 1.382 0 01-1.121.684h-.064z'
          transform='translate(1447.999 174.91)'
        ></Path>
      </G>
    </Svg>
)

const CompleteIcon = () => (
    <View style={styles.container}>
        <View style={styles.icon}>
            <Icon />
        </View>
        <Text style={styles.text}>Complete</Text>
    </View>
);

export default CompleteIcon;
